let api = ""
if (window.location.hostname === "bug-free-cod-v5xrpxxqqj7hrpx-3000.app.github.dev") {
  // api = "http://localhost:7071"
  api = "https://improved-couscous-4rxvqxxw9rxcq59x-7071.app.github.dev"
  // api = "https://bug-free-cod-v5xrpxxqqj7hrpx-3000.app.github.dev"
}

export const ENV = {
  api
};